import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';
import React from 'react';
import Lottie from 'lottie-react';
import voiceDefaultAnimation from '../../assets/lottieJson/Voice UI.json';
// import voiceProcessingAnimation from '../../assets/lottieJson/Voice Processing.json';
import voiceProcessingNewAnimation from '../../assets/lottieJson/Voice Processing State.json';
import voiceSpeakingAnimation from '../../assets/lottieJson/Voice Speaking.json';

const waveAnim = keyframes`
  0%, 100% { transform: scaleY(1); }
  50%      { transform: scaleY(.6); }
  75%      { transform: scaleY(.8); }
`;

const blinkAnim = keyframes`
  0%, 100% { opacity: 0.3; }
  50%      { opacity: 1;   }
`;

const heights = [
  12, 48, 80, 112, 128, 112, 80, 48, 12, 20, 48, 80, 112, 128, 112, 80, 48, 12,
  20, 48, 80, 112, 128, 112, 80, 48, 12,
];

interface WaveformBarsProps {
  state: 'default' | 'listening' | 'speaking' | 'processing';
  isMuted: boolean;
}

const WaveformBarsAnimation: React.FC<WaveformBarsProps> = ({
  state,
  isMuted,
}) => {
  const isActive = state === 'listening' || state === 'speaking';

  if (state === 'default') {
    return (
      <Box sx={{ height: '400px' }} data-testid="voice-default-animation">
        <Lottie
          animationData={voiceDefaultAnimation}
          loop={!isMuted}
          autoplay={!isMuted}
          style={{ height: '100%', color: 'white' }}
          data-testid="voice-default-lottie"
        />
      </Box>
    );
  }
  if (state === 'processing') {
    return (
      <Box sx={{ height: '280px' }} data-testid="voice-processing-animation">
        <Lottie
          animationData={voiceProcessingNewAnimation}
          loop={true}
          autoplay={true}
          style={{ height: '100%', color: 'white' }}
          data-testid="voice-processing-lottie"
        />
      </Box>
    );
  }
  if (isActive) {
    return (
      <Box sx={{ height: '360px' }} data-testid="voice-speaking-animation">
        <Lottie
          animationData={voiceSpeakingAnimation}
          loop={true}
          autoplay={true}
          style={{ height: '100%', color: 'white' }}
          data-testid="voice-speaking-lottie"
        />
      </Box>
    );
  }

  return (
    <Box
      data-testid="voice-waveform-bars"
      sx={{
        height: '128px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {heights.map((height: number, idx: number) => {
        const delay = `${(idx * 0.2).toFixed(1)}s`;
        const animation = isActive
          ? `${blinkAnim} 2s ease-in-out infinite ${delay}, ${waveAnim} 1s ease-in-out infinite ${delay}`
          : `${blinkAnim} 1s ease-in-out infinite ${delay}`;

        return (
          <Box
            key={idx}
            data-testid={`waveform-bar-${idx}`}
            sx={
              {
                width: '8px',
                height: `${isActive ? height : 24}px`,
                mx: '6px',
                backgroundColor: 'white',
                borderRadius: '4px',
                transformOrigin: 'center',
                animation,
              } as any
            }
          />
        );
      })}
    </Box>
  );
};

export default WaveformBarsAnimation;
